/* Keep the native sticky-header placeholder in sync with late-loading account icons and fonts. */
(() => {
  let observer;
  function syncHeader() {
    observer?.disconnect();
    const header = document.getElementById('SiteHeader');
    if (!header || !window.ResizeObserver) return;
    const update = () => {
      const placeholder = document.getElementById('StickyHeaderWrap');
      if (!placeholder || header.classList.contains('site-header--stuck')) return;
      const height = Math.ceil(header.getBoundingClientRect().height);
      if (!height) return;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      placeholder.style.height = `${height}px`;
    };
    observer = new ResizeObserver(update);
    observer.observe(header);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncHeader);
  else syncHeader();
  document.addEventListener('shopify:section:load', syncHeader);
})();

/* Localise only the store-locator component, including results loaded after a search. */
(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('de') || !location.pathname.endsWith('/pages/store-locator')) return;
  const labels = new Map([
    ['Search Location', 'Ort oder Postleitzahl suchen'], ['Search', 'Suchen'],
    ['Find Me', 'Mein Standort'], ['Locate Me', 'Standort ermitteln'],
    ['Clear Text', 'Eingabe löschen'], ['Filters', 'Filter'], ['Clear', 'Zurücksetzen'], ['Apply', 'Anwenden'],
    ['Open Website', 'Website besuchen'], ['Get Directions', 'Route planen'], ['Reset', 'Zurücksetzen'],
    ['Filter stores using name or address', 'Händler nach Name oder Adresse filtern'],
    ['Search a location to get stores', 'Suche nach einem Ort, um Händler in deiner Nähe zu finden.'],
    ["Sorry, we didn't find any store", 'Wir haben in diesem Bereich keinen Händler gefunden.'],
    ['No matched store found', 'Kein passender Händler gefunden.'],
    ["Map doesn't have access to your location", 'Du hast den Standortzugriff nicht freigegeben. Suche nach Ort oder Postleitzahl.'],
    ['Our Locations', 'Unsere Händler'], ['Show Fullscreen', 'Vollbild öffnen'],
    ['Exit Fullscreen', 'Vollbild schließen'], ['Zoom In', 'Vergrößern'], ['Zoom Out', 'Verkleinern']
  ]);
  const translate = value => {
    const trimmed = value.trim();
    const result = labels.get(trimmed) || (/^Showing \d+ results$/.test(trimmed) ? trimmed.replace(/^Showing (\d+) results$/, '$1 Händler gefunden') : null);
    return result ? value.replace(trimmed, result) : value;
  };
  let rootObserver;
  function mount() {
    const root = document.querySelector('.sg__storelocator_wrapper');
    if (!root) return false;
    const update = () => {
      root.querySelectorAll('[placeholder],[aria-label],[title]').forEach(element => {
        ['placeholder', 'aria-label', 'title'].forEach(attribute => {
          const value = element.getAttribute(attribute);
          if (value && translate(value) !== value) element.setAttribute(attribute, translate(value));
        });
      });
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (['SCRIPT', 'STYLE'].includes(node.parentElement?.tagName)) continue;
        const value = node.nodeValue;
        if (value && translate(value) !== value) node.nodeValue = translate(value);
      }
    };
    update();
    rootObserver = new MutationObserver(update);
    rootObserver.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['placeholder','aria-label','title'] });
    return true;
  }
  function init() {
    if (mount()) return;
    const pending = new MutationObserver(() => { if (mount()) pending.disconnect(); });
    pending.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
